import * as ko from "knockout";
import * as _ from "underscore";
import { App } from "./app";
import { Api } from "./app-api";
import { Region, Toastr } from "./app-models";

export class Cart {
    payment: PaymentSummary;
    region: Region;

    registrations = ko.observableArray<Registration>();

    cancel: () => void;
    cancelRegistration: (item: Registration) => void;

    constructor(data: any, public returnUrl: string) {
        let self = this;

        self.payment = data.payment ? new PaymentSummary(data.payment) : null;
        self.region = new Region(data.region);

        var temp = self.registrations();

        _(data.registrations).each(x => temp.push(new Registration(x, self)));

        self.registrations(temp);

        self.cancelRegistration = (item: Registration) => {
            var msg = "Are you sure that you want to remove this Registration?";
            self.cancelWarning(msg, item);
        }

        self.cancel = () => {
            var msg = "Are you sure that you want to Cancel? This cannot be undone.";
            self.cancelWarning(msg);
        }
    }

    private cancelWarning(msg: string, item?: Registration) {
        let self = this;

        if (!Toastr.confirm(msg)) { return; }

        var data = {
            id: item ? item.id : null,
            returnUrl: self.returnUrl
        }

        Api.Cancel(data)
            .done(results => {
                if (results.error) { App.alertError(results.message); return; }
                if (results.empty) { window.location.href = results.nextUrl; }
                if (results.id) { self.registrations.remove(item); }
            });
    }
}

export class Camp {
    id: number;
    location: Location;
    program: Program;
    dates: string;
    price: string;
    startDate: string;

    constructor(data: any) {
        let self = this;

        self.id = data.id;
        self.location = new Location(data.location);
        self.program = new Program(data.program);
        self.dates = data.dates;
        self.price = data.price;
        self.startDate = data.startDate;
    }
}

export class Child {
    id: number;
    name: string;
    age: number;
    birthDate: string;

    constructor(data: any) {
        let self = this;

        self.id = data.id;
        self.name = data.name;
        self.age = data.age;
        self.birthDate = data.birthDate;
    }
}

export class Location {
    id: number;
    name: string;

    constructor(data: any) {
        let self = this;

        self.id = data.id;
        self.name = data.name;
    }
}

export class PaymentSummary {
    credit: string
    discount: any;
    noBalance: boolean;
    subTotal: string;
    total: string;

    tax: Tax[];

    hasCredit: boolean;
    hasDiscount: boolean;
    hasTax: boolean;

    constructor(data: any) {
        let self = this;

        self.credit = data.credit;
        self.discount = data.discount;
        self.noBalance = data.noBalance;
        self.subTotal = data.subTotal;
        self.total = data.total;

        self.tax = _(data.tax).map(x => new Tax(x));

        self.hasCredit = App.hasVal(self.credit);
        self.hasDiscount = App.hasVal(self.discount);
        self.hasTax = _(self.tax).any();
    }
}

export class Product {
    id: number;
    name: string;
    price: string;

    inputId: string;

    constructor(registration: number, data: any) {
        let self = this;

        self.id = data.id;
        self.name = data.name;
        self.price = data.price;

        self.inputId = registration.toString() + '_' + self.id.toString();
    }
}

export class ProductOptions {
    extraCare: Product[];
    products: Product[];

    constructor(registration: number, data: any) {
        let self = this;

        self.extraCare = _(data.extraCare).map(x => new Product(registration, x));
        self.products = _(data.products).map(x => new Product(registration, x));

        //self.products = [..._(data.extraCare).map(x => new Product(x)), ..._(data.products).map(x => new Product(x))];
    }
}

export class Program {
    id: number;
    name: string;

    textCss: string;

    constructor(data: any) {
        let self = this;

        self.id = data.id;
        self.name = data.name;

        self.textCss = App.programTextCss(self.id);
    }
}

export class Registration {
    id: number;
    allocation: string;
    camp: Camp;
    child: Child;
    productOptions: ProductOptions;
    skillCategory: string;
    skillLevels: SkillLevel[];
    skillLevelsText: string;
    times: string;

    selectedChild: Child;
    selectedSkillLevel: SkillLevel;

    selectedExtraCare = ko.observableArray<Product>();
    selectedProducts = ko.observableArray<Product>();

    cancel: () => void;

    constructor(data: any, cart: Cart) {
        let self = this;

        self.id = data.id;
        self.allocation = data.camp.id + "-" + data.categoryTime.id + "-" + data.skillCategory.id;
        self.camp = new Camp(data.camp);
        self.child = data.child ? new Child(data.child) : null;
        self.productOptions = data.productOptions ? new ProductOptions(data.id, data.productOptions) : null;
        self.skillCategory = data.skillCategory.name;
        self.skillLevels = _(data.skillCategory.skillLevels).map(x => new SkillLevel(x));
        self.skillLevelsText = _(self.skillLevels).pluck("name").join(", ");
        self.times = data.categoryTime.text;

        if (data.skillLevel)
            self.selectedSkillLevel = _(self.skillLevels).find(x => x.id == data.skillLevel);
        else if (self.skillLevels.length == 1)
            self.selectedSkillLevel = self.skillLevels[0];

        if (_(self.productOptions).any()) {
            // back to options
            _(data.extraCare).each((x: any) => {
                var match = _(self.productOptions.extraCare).find(y => y.id == x.id);

                if (match)
                    self.selectedExtraCare.push(match);
            });

            _(data.products).each((x: any) => {
                var match = _(self.productOptions.products).find(y => y.id == x.id);

                if (match)
                    self.selectedProducts.push(match);
            })
        }
        else {
            // checkout
            self.selectedExtraCare(data.extraCare ? _(data.extraCare).map(x => new Product(data.id, x)) : []);
            self.selectedProducts(data.products ? _(data.products).map(x => new Product(data.id, x)) : []);
        }

        self.cancel = () => {
            cart.cancelRegistration(self);
        }
    }
}

export class SkillLevel {
    id: number;
    name: string;
    minAge: number;

    constructor(data: any) {
        let self = this;

        self.id = data.id;
        self.name = data.name;
        self.minAge = data.minAge;
    }
}

export class Tax {
    name: string;
    amount: string;

    constructor(data: any) {
        let self = this

        self.name = data.name;
        self.amount = data.amount;
    }
}
